import {Box, Card, Flex, Text, Title} from "@mantine/core";
import {Categories} from "src/entities/categories";
import styles from "./style.module.scss"
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {Content} from "src/shared/helpers/content";
import {ArrowUp} from "src/shared/ui/icons/arrow-up";
import {KeyIcon} from "src/shared/ui/icons/key";

type Props = {
    data: Categories;
    isParent?: boolean;
}

export const CategoryItem = ({data, isParent=false}: Props) => {
    const {i18n} = useTranslation()
    const locale = i18n.language

    return (
        <Link to={isParent ? `/${locale}/children/${data.id}` : `/${locale}/category/${data.id}`}>
            <Card className={styles.card}>
                <Flex align="center" justify="space-between" mb={32}>
                    <Box className={styles.icon}>
                        <KeyIcon/>
                    </Box>
                    <Box className={styles.arrow_icon}>
                        <ArrowUp/>
                    </Box>
                </Flex>
                <Title className={styles.title} lh={1.3}>
                    {Content.GetTitleByLanguage(data, locale)}
                </Title>
                <Text className={styles.text} lineClamp={2}>
                    {Content.HtmlRenderFromLocale({
                        titleKg: data?.contentKg,
                        titleRu: data?.contentRu,
                    }, locale)}
                </Text>
            </Card>
        </Link>
    )
}